import DefaultModal from "Components/Modal/DefaultModal";
import React from "react";
import { ListGroup, ListGroupItem } from "reactstrap";
import { legend, legendRight } from "../modalsData";
import ColumnHeader from "./ColumnHeader";

export default function LegendModal({ isOpen, setIsOpen }) {
  return (
    <DefaultModal
      modal={isOpen}
      header="Legenda"
      headerColor={"#FFA73F"}
      toggle={() => setIsOpen(false)}
      showFooterBtns={false}
      classes="modal-dialog__over feedback-modal-style planscreen__modal planscreen__modal--legend"
    >
      <div
        className="border rounded-2 legend-table"
        style={{
          backgroundColor: "#FAFCFD",
          display: "grid",
          gridTemplateColumns: "1fr 0.9fr",
          borderColor: "#D0DFE7",
        }}
      >
      
        <ListGroup flush className="legend-column border-end m-0">
          {legend.map((item, index) => {
            const stateCount = item.state.length;
            const isLast = index === legend.length - 1;
            const isRainbow = ["FV", "FB", "SV", "S%", "B%"].includes(item.label);

            return (
              <ListGroupItem
                className={`d-flex align-items-center p-0 bg-transparent ${
                  !isLast ? "border-bottom" : ""
                }`}
                key={index}
              >
                <div
                  className={`border-end ${
                    isRainbow
                      ? "rainbow-column"
                      : "d-flex align-items-center justify-content-center"
                  }`}
                  style={{ minWidth: "90px" }}
                >
                  {stateCount > 0 ? (
  item.state.map((state, i) => (
    <ColumnHeader
      key={i}
      value={state}
      name={item.label}
      crossed={state === "disabled"} // 👈 если disabled — перечёркиваем
    />
  ))
) : (
  <div>{item.label}</div>
)}
                </div>

                <div className="py-2 px-3 flex-grow-1">{item.description}</div>
              </ListGroupItem>
            );
          })}
        </ListGroup>

       
        <ListGroup flush className="legend-column legend-column-right m-0">
          {legendRight.map((item, index, arr) => {
            const isLast = index === arr.length - 1;

            return (
              <ListGroupItem
                key={index}
                className={`d-flex align-items-center p-0 bg-transparent ${
                  !isLast ? "border-bottom" : ""
                }`}
              >
                <div
                  style={{ minWidth: "90px" }}
                  className="border-end d-flex justify-content-center align-items-center"
                >
                  <span>{item.icon}</span>
                </div>
                <div className="py-2 px-3 flex-grow-1">{item.text}</div>
              </ListGroupItem>
            );
          })}

       
          {Array.from({ length: 18 }).map((_, i) => (
            <ListGroupItem
              key={`empty-${i}`}
              className="d-flex align-items-center p-0 bg-transparent border-bottom"
            >
              <div
                style={{ minWidth: "90px", height: "40px" }}
                className="border-end d-flex justify-content-center align-items-center"
              >
                <span style={{ opacity: 0 }}>•</span>
              </div>
              <div className="py-2 px-3 flex-grow-1">&nbsp;</div>
            </ListGroupItem>
          ))}
        </ListGroup>
      </div>
    </DefaultModal>
  );
}